import React, { useEffect, useState } from "react";
import ListPage from "../../../../../../presentation/pages/admin/super-devs/list";
import { toastUtils } from "../../../../../../utils";
import { FilterType, UserResponseModel } from "../../../../../../domain/models/user";
import { makeRemoteSuperDev } from "../../../../usecases/user/remote-user-factory";
import { settings } from "../../../../../configs/settings";

function MakeSupeDevList(): JSX.Element {
  const [list, setList] = useState<UserResponseModel>();
  const refFilters = React.useRef<FilterType>({});
  const [loading, setLoading] = useState<boolean>();

  const loadData = async (filters?: FilterType): Promise<void> => {
    try {
      setLoading(true);
      const response = await makeRemoteSuperDev().list(filters);
      setList(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData({ page: 0, size: settings.perPage });
  }, []);

  const handleReload = (filters: FilterType): void => {
    refFilters.current = filters;
    const aux = { ...refFilters.current };
    Object.assign(aux, filters);
    refFilters.current = aux;
    loadData(aux);
  };

  const handleDelete = async (id: number): Promise<void> => {
    try {
      setLoading(true);
      await makeRemoteSuperDev().delete(id);
      toastUtils.showMessage({
        type: "success",
        message: "Excluído com Sucesso!",
      });
      loadData(refFilters.current);
    } catch (error: any) {
      toastUtils.showMessage({
        type: "error",
        message: error?.userMessage || error?.detail,
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ListPage
      list={list}
      loading={loading}
      handleReload={handleReload}
      handleDelete={handleDelete}
    />
  );
}

export default MakeSupeDevList;
